import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Comment } from '@miq/shared-models';
import { NgClass, DatePipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { L10nTranslationModule } from 'angular-l10n';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line
  selector: '[miq-entry-comment]',
  template: `
    <div class="comment" [ngClass]="{ 'other flt-left': !comment().itsMe, 'mines flt-right': comment().itsMe }">

      <p class="comment-txt" [innerHTML]="comment().message"></p>

      @if (isCommentEdited()) {
        <div class="edited-label">
          <mat-icon class="edited-icon"
            [matTooltip]="('shared.updatedAt' | translate) + ' ' + (comment().updatedTs | date: 'medium')"
            matTooltipPosition="above">
            history
          </mat-icon>
          <span>{{ 'shared.edited' | translate }}</span>
        </div>
      }

      <div class="comment-meta">
        <span>{{ comment().createBy }}</span>
        <span>{{ comment().createTs | date: 'medium' }}</span>
        @if (comment().itsMe) {
          <button mat-icon-button class="edit-btn" (click)="editRequested.emit(comment())" [attr.aria-label]="'shared.editComment' | translate">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>

    </div>
  `,
  styleUrl: './entry-comment.component.scss',
  imports: [NgClass, DatePipe, MatIconButton, MatIcon, MatTooltip, L10nTranslationModule],
})
export class EntryCommentComponent {
  comment = input<Comment>();
  self = input(false);

  /** Emits the comment to the parent when the user wants to edit it. */
  editRequested = output<Comment>();

  /** True only when updatedTs is meaningfully later than createTs (> 1 s). */
  isCommentEdited(): boolean {
    const c = this.comment();
    if (!c?.updatedTs) return false;
    if (!c.createTs) return true;
    return new Date(c.updatedTs).getTime() - new Date(c.createTs).getTime() > 1000;
  }
}
